<template>
  <v-stepper-header :class="headerClass">
    <template v-for="(step, index) in normalizedSteps">
      <v-stepper-step
        :key="`step-${entityType}-${index}`"
        :step="index + 1"
        :class="stepClass(index)"
        :complete="index + 1 < currentStep"
      >
        <slot name="step" :step="step" :index="index">
          {{ step.title }}
        </slot>
      </v-stepper-step>
      <v-divider
        v-if="index < normalizedSteps.length - 1"
        :key="`divider-${entityType}-${index}`"
      />
    </template>
  </v-stepper-header>
</template>

<script>
export default {
  name: "Stepper",
  props: {
    steps: {
      type: Array,
      required: true,
    },
    currentStep: {
      type: Number,
      default: 1,
    },
    entityType: {
      type: String,
      default: "default",
    },
    headerExtraClass: {
      type: String,
      default: "",
    },
    stepExtraClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    normalizedSteps() {
      return this.steps.map((s) => {
        if (typeof s === "string") {
          return { title: s };
        }
        return { title: s.title || "", ...s };
      });
    },
    headerClass() {
      return this.headerExtraClass || undefined;
    },
  },
  methods: {
    stepClass(index) {
      const classes = ["v-stepper-step-outline"];
      if (this.stepExtraClass) {
        classes.push(this.stepExtraClass);
      }
      return classes;
    },
  },
};
</script>
